import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { doLogin, resetLoginErrors } from '../actions/actionCreators'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Button, Card, Form, Image, Input, Divider } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import Logo from '../images/logo-admin.png'
import { useHistory } from 'react-router-dom'
import LanguageSelector from './LanguageSelector';
import { Text, Translate, LanguageContext } from '../helpers/language';
import { NotificationManager } from 'react-notifications';


const Login = (props) => {
  const languageContext = useContext(LanguageContext);
  const [credits, setCredits] = useState({
    email: '',
    password: ''
  })
  
  const history = useHistory()    
  const error = props.auth.error
  const message = Translate(languageContext, props.auth.message) ? Translate(languageContext, props.auth.message) : props.auth.message
  
  useEffect(() => {
    //if there are some errors display and reset
    if (message && error) {
      window.dataLayer.push({
        event: 'user_event',
        eventProps: {
          category: 'user_action',
          action: 'login_failed',
          label: 'User Login Failed',
          value: 'false'
      }
      });
      
      NotificationManager.error(message, null, 1500);
      props.dispatch(resetLoginErrors())
    }
  }, [])


  const logIn = (event) => {    
    event.preventDefault();    
    const email = credits.email;
    const password = credits.password;
    window.dataLayer.push({
      event: 'user_event',
      eventProps: {
        category: 'user_action',
        action: 'login_attempt',
        label: 'User Login Attempt',
        value: email
    }
    });
    props.dispatch(doLogin({ email, password }));
  }

  const handlePasswordChange = (event) => {
    setCredits({...credits, password: event.target.value});
  }

  const handleEmailChange = (event) => {
    setCredits({...credits, email: event.target.value});
  }
   

  //if logged in redirect to main page
  if (props.auth.isLogged) {
    window.dataLayer.push({
      event: 'user_event',
      eventProps: {
        category: 'user_action',
        action: 'login',
        label: 'User Login',
        value: 'true'
    }
    });
    history.push('/') 
  }


  return (
      <div className="login lisia-dialog lisia-centered-dialog">
        <Row center="xs">
          <Col xs={12} className='login-wrapper'>
            <Card fluid={true} raised={true} centered={true} >
              <Card.Content>
                <div className='header loginLanguageSelector' >
                  <LanguageSelector />
                </div>
                <div className="login-form">
                  <a href="https://www.lisia.it" target="_blank">
                    <Image size='small' src={ Logo } className='m-b-10'/>
                  </a>
                  <Form onSubmit={logIn}>
                    <Form.Field>
                      <Input icon='user' iconPosition='left' value={credits.email} onChange={handleEmailChange} name="email" placeholder={Translate(languageContext,'email')} />
                    </Form.Field>
                    <Form.Field>
                      <Input icon='lock' iconPosition='left' value={credits.password} onChange={handlePasswordChange} type="password" placeholder={Translate(languageContext,'password')} />
                    </Form.Field>                    
                    <Button type="submit" className='lisia-blue' fluid>
                    <Text tid="login" />
                    </Button>
                    <Divider />
                    <div className="footer">
                      <Link to="/registration" className='secondary-link' >
                        <Text tid="signup" />
                      </Link>
                      <Link to="/restore">
                        <Text tid="restore_password" />
                      </Link>
                    </div>
                  </Form>
                </div>
              </Card.Content>
            </Card>
          </Col>
        </Row>
      </div>
  )

}

Login.propTypes = {
  auth: PropTypes.object
}

const mapStateToProps = (state) => ({
  auth: state.auth,
})

export default connect(mapStateToProps)(Login)
